import React from 'react';
import styled from 'styled-components';

// Material UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import withStyles from '@material-ui/core/styles/withStyles';
import { Fab } from '@material-ui/core';

// Data
import { mainColor } from '../../../../lib/theme';
import {
  useIsNavCollapsed,
  useIsContextCollapsed,
  setIsContextCollapsed
} from '../../../../lib/stores/dashboard-layout.store';

// Components
import { GlobalAgeGroupFilterGraphQL } from '../../../AgeGroup/GlobalAgeGroupFilter/global-age-group-filter.graphql';
import { AssessmentSelectorLayout } from './assessment-selector.layout';

interface IWrapper {
  isNavCollapsed?: boolean;
  isCollapsed?: boolean;
}

const Wrapper = styled.div<IWrapper>`
  background: #fff;
  padding: ${props => props.isCollapsed ? 0 : '24px'};
  margin-right: 24px;
  height: 100%;
  box-shadow: 0 0 24px 8px rgba(0,0,0,0.05);
  width: ${props => props.isCollapsed ? '16px' : '300px'};
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: ${props => props.isNavCollapsed ? '64px' : '180px'};
  overflow-y: auto;

  & > *:first-child {
    margin-top: 0;
  }
`;

const ToggleFab = withStyles(() => ({
  root: {
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    position: 'fixed',
    top: '35px',
    color: '#fff',
    background: mainColor,
    width: '24px',
    height: '24px',
    minHeight: 'auto',
    zIndex: 101
  }
}))(Fab);

const DashboardSidebar = ({requiredRoles, hideAgeGroupFilter}: {requiredRoles?: string[]; hideAgeGroupFilter?: boolean}) => {
  const isNavCollapsed = useIsNavCollapsed();
  const isCollapsed = useIsContextCollapsed();

  return (
    <Wrapper isNavCollapsed={isNavCollapsed} isCollapsed={isCollapsed}>
      {!isCollapsed && (<ToggleFab style={{ left: isNavCollapsed ? '352px' : '467px' }} onClick={() => setIsContextCollapsed(!isCollapsed)}>
        {isCollapsed
          ? <ArrowRightIcon style={{ position: 'relative', left: '1px', top: '1px' }} />
          : <ArrowLeftIcon style={{ position: 'relative', top: '1px' }} />
        }
      </ToggleFab>)}
      {!isCollapsed && <>
        <Box display="flex" alignItems="center">
          <AssessmentSelectorLayout requiredRoles={requiredRoles} />
        </Box>
        {!hideAgeGroupFilter && (
          <Box mt={2}>
            <Typography variant="h6">Age Groups</Typography>
            <Box py={2}>
              <GlobalAgeGroupFilterGraphQL requiredRoles={requiredRoles} />
            </Box>
          </Box>
        )}
      </>}
    </Wrapper>
  );
};

export default DashboardSidebar;
